export const companiesCompanyIdDevelopersPermissionStructures =
  "/companies/:company_id/developers/permission_structures";
